import { render, staticRenderFns } from "./resultPage.vue?vue&type=template&id=1e15e5e5&scoped=true&"
import script from "./resultPage.vue?vue&type=script&lang=ts&"
export * from "./resultPage.vue?vue&type=script&lang=ts&"
import style0 from "./resultPage.vue?vue&type=style&index=0&id=1e15e5e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e15e5e5",
  null
  
)

export default component.exports